import React, { useMemo, useState, useEffect } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'

import Card from '../../../components/Card'
import { API_CALL_CENTRE_LIST, LICENCE_HISTORY_LIST } from '../../../service/url';
import { getApiCall } from '../../../service/httpCall';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import switchUserIcon from '../../../assets/images/icons/switch-user.png';
import { switchAs } from '../../../utilities/setting';
import ToastNotification from '../../../components/Toast';
import { toast } from 'react-toastify';
import { USER_ROLES, MODULE_ACL } from '../../../utilities/constant';
import { ROUTES } from '../../../utilities/constant';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { useAuth, errorCheck } from '../auth/auth-utils';
import exportData from '../../../utilities/export';
import { Button } from 'primereact/button';
import "../../../assets/custom/css/custom.css";
import { getUser } from "../../../utilities/setting";
import { Modal } from 'react-bootstrap';
import { postApiCall } from '../../../service/httpCall';
import { API_CALL_CENTRE_DELETE } from '../../../service/url';
import { FaTrash } from "react-icons/fa";
import LicenceHistoryList from '../licence_history/list';
import { FileText, Flag } from 'lucide-react';
import CountryCodeDirectionsModal from '../../../components/partials/dashboard/country-code-direction/CountryCodeDirectionsModal';



//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css';
//core
import 'primereact/resources/primereact.min.css';
import Loader  from '../../../components/partials/components/loader';

const CallCentreList = () => {

   const navigate = useNavigate();
   const [callCentreList, setCallCentreList] = useState([]);
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [loading, setLoading] = useState(false);
   const [buttonDisable, setButtonDisable] = useState(false);
   const [currentUserId, setCurrentUserId] = useState("")
   const [currentUserRole, setCurrentUserRole] = useState("")
   const [searchValue, setSearchValue] = useState("");
   const [loggedInUserACL, setLoggedInUserACL] = useState({})
   const [isSuperAdmin, setIsSuperadmin] = useState(false)
   const [showDeleteModal, setShowDeleteModal] = useState(false);
   const [deleteId, setDeleteId] = useState(null);
   const [showLicenceHistoryModal, setShowLicenceHistoryModal] = useState(false);
const [selectedLicenceCallcentreId, setSelectedLicenceCallcentreId] = useState(null);
const [selectedLicenceCallcentreName, setSelectedLicenceCallcentreName] = useState(null);
const [licenceHistoryCounts, setLicenceHistoryCounts] = useState({});
const [showCcDirectionsModal, setShowCcDirectionsModal] = useState(false);
const [ccDirectionsData, setCcDirectionsData] = useState([]);
const [ccDirectionsOwner, setCcDirectionsOwner] = useState("");
   
   useEffect(() => {
      const user = getUser();
         if (user) {
            setCurrentUserId(user?.company?.id)
            setCurrentUserRole(user.role)
         }
         if (user.role === USER_ROLES.SUPERADMIN) {
            setIsSuperadmin(true);
         }
         if (user?.acl_settings) {
            setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
         }
   }, []);

   const handleExport = async () => {
   try {
      setButtonDisable(true);

      exportToCSV({
         fileName: "call-centers-list",
         data: displayedCallCentreList,
         columns: [
            {
               header: "#",
               accessor: "key"
            },
            {
               header: "Name",
               accessor: (row) =>
                  row.name || "-"
            },
            {
               header: "Domain",
               accessor: (row) =>
                  row.domain || "-"
            },
            {
               header: "Created Date",
               accessor: (row) =>
                  new Date(row.created_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            },
            {
               header: "Updated Date",
               accessor: (row) =>
                  new Date(row.updated_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            }
         ]
      });

   } finally {
      setButtonDisable(false);
   }
};

   useEffect( () => {
      setLoading(true);
      getApiCall(API_CALL_CENTRE_LIST, {})
      .then(onCallCentreListSuccess)
      .catch(onError)
      .finally(() => setLoading(false));

   }, []);

   const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});

     useEffect(() => {
      const user = getUser();
         if (user) {
           if (user?.acl_settings) {
             setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
           }
         }
     }, []);

     useEffect(() => {
       const onAclRefreshed = () => {
         const user = getUser();
         if (user?.acl_settings?.module_operations) {
           try {
             const parsed = typeof user.acl_settings.module_operations === "string"
               ? JSON.parse(user.acl_settings.module_operations)
               : user.acl_settings.module_operations;
             setLoggedInUserACL(parsed);
             setModuleOperationsForReadPermissionCheck(parsed);
           } catch (e) {
             console.log("Failed to apply refreshed ACL", e);
           }
         }
       };
       window.addEventListener("acl-refreshed", onAclRefreshed);
       return () => window.removeEventListener("acl-refreshed", onAclRefreshed);
     }, []);

   // useEffect( () => {

   //    if(toastProps){
   //       setShowToast(true);
   //    }

   // }, [toastProps]);


   function onCallCentreListSuccess(resp){
      const updatedList = resp.map( (val, idx) => {
         val['key'] = idx+1;
         val['created_at'] = new Date(val['created_at']).toGMTString();
         return val;
      } );
      setCallCentreList(updatedList);
    }
    



   function switchAsCallCentre(id, name){

      const switchAccountSuccess = switchAs( USER_ROLES.CALL_CENTRE, id, name );
      if(switchAccountSuccess){
           toast.success('Account switched successfully');
         setTimeout( function(){
            const callCentreUsersListPath = ROUTES.CALL_CENTRES.USERS.LIST.replace(':id', id);
            //navigate(`/${callCentreUsersListPath}`);
            window.location.href = callCentreUsersListPath;
         }, 1500);
      }

   }

    useEffect(() => {
    if (callCentreList.length === 0) return;

    const fetchCounts = async () => {
        const counts = {};
        await Promise.all(
            callCentreList.map(async (cc) => {
                if (!cc.id) return;
                try {
                    const queryParams = new URLSearchParams();
                    queryParams.append("callcenter_id", cc.id);
                    const url = `${LICENCE_HISTORY_LIST}?${queryParams.toString()}`;
                    const resp = await getApiCall(url);
                    const data = Array.isArray(resp) ? resp : (resp?.data || []);
                    counts[cc.id] = data.length;
                } catch {
                    counts[cc.id] = 0;
                }
            })
        );
        setLicenceHistoryCounts(counts);
    };

    fetchCounts();
}, [callCentreList]);




   const handleAllocateClick = (id, role) => {
      navigate(`/allocate/${id}/${currentUserId}/callcentre`);
    };

    const ccDirectionsTemplate = (rowData) => {
       const rows = (rowData.callcenterCountryCodeDirections || []).filter(r => r.directionMaster && !r.is_deleted);
       if (rows.length === 0) {
         return <span style={{ color: "#6b7280", fontSize: "13px" }}>No Directions</span>;
       }
       return (
         <Button
           onClick={() => {
             setCcDirectionsData(rows);
             setCcDirectionsOwner(rowData.name);
             setShowCcDirectionsModal(true);
           }}
           className="p-button-active p-button-sm"
           style={{ padding: "5px 10px", display: "inline-flex", alignItems: "center", gap: "6px" }}
         >
           <Flag size={16} />
           <span>View Directions</span>
         </Button>
       );
    };

    const licenceHistoryTemplate = (rowData) => {
    if (!rowData.id) return "N/A";

if (licenceHistoryCounts[rowData.id] === 0) {
        return <span style={{ color: "#6b7280", fontSize: "13px" }}>No History</span>;
    }


    return (
        <Button
            onClick={() => {
                setSelectedLicenceCallcentreId(rowData.id);
                setSelectedLicenceCallcentreName(rowData.name);
                setShowLicenceHistoryModal(true);
            }}
            className="p-button-active p-button-sm"
            style={{ padding: "5px 10px", display: "inline-flex", alignItems: "center", gap: "6px" }}
        >
            <FileText size={16} />
            <span>View History</span>
        </Button>
    );
};


   function RenderActionComponent(id, name){

      const editUrl = ROUTES.CALL_CENTRES.EDIT.replace(':id', id);

      return (
         <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {(isSuperAdmin || loggedInUserACL[MODULE_ACL.CALL_CENTRE]?.edit) && (
               <Link
                  className="btn btn-sm btn-warning"
                  title="Edit"
                  to={`/${editUrl}`}
                  style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "34px", width: "34px" }}
               >
                  <span className="btn-inner">
                     <svg width="18" viewBox="0 0 24 24" fill="none">
                        <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="#000" strokeWidth="1.5"/>
                        <path d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="#000" strokeWidth="1.5"/>
                     </svg>
                  </span>
               </Link>
            )}

            <Button
               className="btn btn-primary btn-sm"
               style={{ height: "34px" }}
               title="Allocate"
               onClick={() => handleAllocateClick(id, name)}
            >
               Allocate Number
            </Button>

            <Button
               className="btn btn-danger btn-sm"
               style={{
                  width: "36px",
                  height: "36px",
                  padding: "0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
               }}
               title="Delete"
               onClick={() => openDeleteModal(id)}
            >
               <FaTrash size={14} />
            </Button>
         </div>
      );
   }

   function openDeleteModal(id) {
      setDeleteId(id);
      setShowDeleteModal(true);
   }

   function closeDeleteModal() {
      setDeleteId(null);
      setShowDeleteModal(false);
   }

   async function confirmDelete() {
      try {
         setButtonDisable(true);

         const url = API_CALL_CENTRE_DELETE.replace(":id", deleteId);
         await postApiCall(url, {});
         toast.success("Call centre deleted successfully");

         closeDeleteModal();
         setLoading(true);
         const resp = await getApiCall(API_CALL_CENTRE_LIST, {});
         onCallCentreListSuccess(resp);

      } catch (err) {
         toast.error(JSON.stringify(err) || "Failed to delete call centre");
         onError(err);
      } finally {
         setLoading(false);
         setButtonDisable(false);
      }
   }


function onError(err) {
   if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
    errorCheck(err, navigate, setToastProps, setShowToast)
 } else {
   console.log(err)
 }
}

const handleCreateButtonClick = () => {
   navigate(`/${ROUTES.CALL_CENTRES.CREATE}`);
} 
   
 const displayedCallCentreList = useMemo(() => {
   const q = searchValue.trim().toLowerCase();
   if (!q) return callCentreList;
   return callCentreList.filter((cc) => (cc?.name || "").toLowerCase().includes(q));
 }, [callCentreList, searchValue]);

   const canRead = hasPermission(
     moduleOperationsForReadPermissionCheck,
     "Call Centres List",
     "read",
   );
 
   if (Object.keys(moduleOperationsForReadPermissionCheck).length > 0 && !canRead) {
     return (
       <div
         className="text-center p-4"
         style={{
           marginTop: "50px",
           marginBottom: "50px",
           fontSize: "16px",
         }}
       >
         No read permission found in assigned ACL
       </div>
     );
   }

 if (loading) {
   return <Loader />
}

  return(
     <>
       <div>
         <Row>
            <Col sm="12">
               <Card>
                  <Card.Header className="d-flex justify-content-between">
                     <div className="header-title">
                        <h4 className="card-title">Call Centre List</h4>
                     </div>
                     {(isSuperAdmin || loggedInUserACL[MODULE_ACL.CALL_CENTRE]?.add) && (
                        <button className="btn btn-primary ml-auto" onClick={handleCreateButtonClick}>Create Call Centre</button>
                     )}
                  </Card.Header>
                  <Card.Body className="px-0">
                     {callCentreList.length > 0 &&
                     <Button 
                     label="Export Data"
                     icon="pi pi-file-export"
                     onClick={handleExport} 
                     className="p-button-active p-button-sm" 
                     style={{ marginBottom: '10px', marginLeft: '10px' }} 
                     disabled={buttonDisable} 
                  >
                     &nbsp;
                     {buttonDisable && (
                        <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                     )}
                  </Button>

                     }

                     <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
                        <Form.Group style={{ marginLeft: "10px", marginTop: "10px", marginBottom: "10px", flexShrink: 0 }}>
                           <Form.Control
                              style={{
                                 height: "50px",
                                 width: "380px",
                                 border: "1px solid #ced4da",
                                 fontSize: "15px",
                              }}
                              placeholder="Search call centre by name..."
                              type="text"
                              maxLength={100}
                              value={searchValue}
                              onChange={(e) => setSearchValue(e.target.value)}
                           />
                        </Form.Group>
                     </div>
                     
                     <div className="scroll-container">
                        <div className="table-responsive border-bottom my-3">
                           <DataTable value={displayedCallCentreList} tableStyle={{ minWidth: '50rem' }}  paginator rows={8}>
                              <Column field="key" header="#"></Column>
                              <Column field="name" filterField="name" header="name" filter filterPlaceholder="Search by name" ></Column>
                              <Column field="domain" filterField="domain" header="domain" filter filterPlaceholder="Search by domain" ></Column>
                              {/* <Column field="subUserLicenceId.total_licence.callcenter" header="Total Licence" ></Column> */}
                              {/* <Column field="subUserLicenceId.available_licence.callcenter" header="Available Licence" ></Column> */}
                              <Column field="created_at" header="Created Date" body={(rowData) =>
                                    new Date(rowData.created_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                              <Column field="updated_at" header="Updated Date" body={(rowData) =>
                                    new Date(rowData.updated_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                                 <Column
    field="country_code_directions"
    header="Country Codes"
    body={ccDirectionsTemplate}
/>
                                 <Column
    field="licence_history"
    header="Licence History"
    body={licenceHistoryTemplate}
/>
                              <Column
                                 header="Actions"
                                 body={(rowData) => RenderActionComponent(rowData.id, rowData.name)}
                              ></Column>
                           </DataTable>
                        </div>
                     </div>
                  </Card.Body>
                  
               </Card>
            </Col>
         </Row>
      </div>
      <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
   <Modal.Header closeButton>
      <Modal.Title>Delete Call Centre</Modal.Title>
   </Modal.Header>

   <Modal.Body>
      Are you sure you want to delete this call centre? Licence Values cannot be returned.
   </Modal.Body>

   <Modal.Footer>
      <Button
         label="Cancel"
         className="p-button-text"
         onClick={closeDeleteModal}
      />

      <Button
         label="Delete"
         className="p-button-danger"
         onClick={confirmDelete}
         disabled={buttonDisable}
      />
   </Modal.Footer>
</Modal>

      {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}


<Modal
    show={showLicenceHistoryModal}
    onHide={() => {
        setShowLicenceHistoryModal(false);
        setSelectedLicenceCallcentreId(null);
        setSelectedLicenceCallcentreName(null);
    }}
    centered
    size="xl"
    dialogClassName="callcentre-licence-history-modal"
>
    <style>{`
        .callcentre-licence-history-modal .modal-header {
            background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important;
            color: white !important;
            border-bottom: none !important;
            border-radius: 14px 14px 0 0 !important;
            padding: 18px 24px !important;
        }
        .callcentre-licence-history-modal .modal-title {
            color: white !important;
            font-size: 20px !important;
            font-weight: 600 !important;
            margin: 0 !important;
        }
        .callcentre-licence-history-modal .btn-close {
            filter: brightness(0) invert(1) !important;
            opacity: 0.8 !important;
        }
        .callcentre-licence-history-modal .modal-content {
            border-radius: 14px !important;
            overflow: hidden;
            box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
        }
        .callcentre-licence-history-modal .modal-body {
            padding: 16px !important;
            max-height: 75vh;
            overflow-y: auto;
        }
    `}</style>
    <Modal.Header>
        <Modal.Title>
            Licence History — {selectedLicenceCallcentreName}
        </Modal.Title>
        <button
            type="button"
            className="btn-close btn-close-white"
            onClick={() => {
                setShowLicenceHistoryModal(false);
                setSelectedLicenceCallcentreId(null);
                setSelectedLicenceCallcentreName(null);
            }}
            aria-label="Close"
        />
    </Modal.Header>
    <Modal.Body>
        {selectedLicenceCallcentreId && (
            <LicenceHistoryList callcenterId={selectedLicenceCallcentreId}
            displayName={selectedLicenceCallcentreName} />
        )}
    </Modal.Body>
</Modal>

<CountryCodeDirectionsModal
  show={showCcDirectionsModal}
  onHide={() => {
    setShowCcDirectionsModal(false);
    setCcDirectionsData([]);
    setCcDirectionsOwner("");
  }}
  title="Call Centre Country Codes"
  ownerLabel="Call Centre Name"
  ownerName={ccDirectionsOwner}
  directions={ccDirectionsData}
/>
     </>
  )

}

export default CallCentreList;